const ExchangeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="40"
      height="40"
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M286.187,268.435L112.968,441.677c-6.875,6.876-18.021,6.876-24.897,0.001L45.214,398.82  c-6.874-6.874-6.875-18.02-0.001-24.894l117.914-117.939l-69.122-69.122l-48.79-48.79c-6.875-6.875-6.875-18.021,0-24.896  l42.857-42.857c6.875-6.875,18.021-6.875,24.896,0l116.543,116.543l56.675,56.675C293.06,250.414,293.061,261.56,286.187,268.435z"
          fill="#00d8de"
          data-original="#00d8de"
        ></path>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M230.853,188.261L163.1,256.014l-25.897-25.897l-43.197-43.252l-48.79-48.79  c-6.875-6.875-6.875-18.021,0-24.896L88.07,70.325c6.876-6.876,18.025-6.875,24.899,0.003l91.987,92.035L230.853,188.261z"
          fill="#00a5ff"
          data-original="#00a5ff"
        ></path>
        <polygon
          xmlns="http://www.w3.org/2000/svg"
          points="230.853,188.261 163.1,256.014 146.67,239.557 214.422,171.804 "
          fill="#0087ff"
          data-original="#0087ff"
        ></polygon>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M466.786,268.435L293.568,441.677c-6.875,6.876-18.022,6.876-24.897,0.001l-42.858-42.858  c-6.874-6.874-6.875-18.02-0.001-24.894l117.914-117.939l-69.122-69.122l-48.79-48.79c-6.875-6.875-6.875-18.021,0-24.896  l42.857-42.857c6.875-6.875,18.021-6.875,24.896,0L410.11,186.865l56.675,56.675C473.66,250.414,473.66,261.56,466.786,268.435z"
          fill="#00a5ff"
          data-original="#00a5ff"
        ></path>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M411.452,188.261l-67.753,67.753l-25.897-25.897l-43.197-43.252l-48.79-48.79  c-6.875-6.875-6.875-18.021,0-24.896l42.854-42.854c6.876-6.876,18.025-6.875,24.899,0.003l91.987,92.035L411.452,188.261z"
          fill="#00d8de"
          data-original="#00d8de"
        ></path>
        <g xmlns="http://www.w3.org/2000/svg">
          <polygon
            points="411.452,188.261 343.699,256.014 327.269,239.557 395.022,171.804  "
            fill="#05c1c1"
            data-original="#05c1c1"
          ></polygon>
          <path
            d="M494.01,488.583c-4.143,0-7.5,3.358-7.5,7.5v8.417c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5   v-8.417C501.51,491.941,498.153,488.583,494.01,488.583z"
            fill="#05c1c1"
            data-original="#05c1c1"
          ></path>
          <path
            d="M449.738,488.583c-4.143,0-7.5,3.358-7.5,7.5v8.417c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5   v-8.417C457.238,491.941,453.881,488.583,449.738,488.583z"
            fill="#05c1c1"
            data-original="#05c1c1"
          ></path>
          <path
            d="M405.466,488.583c-4.143,0-7.5,3.358-7.5,7.5v8.417c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5   v-8.417C412.966,491.941,409.608,488.583,405.466,488.583z"
            fill="#05c1c1"
            data-original="#05c1c1"
          ></path>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="M106.534,23.417c4.142,0,7.5-3.358,7.5-7.5V7.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v8.417   C99.034,20.059,102.392,23.417,106.534,23.417z"
            fill="#0087ff"
            data-original="#0087ff"
          ></path>
          <path
            d="M62.262,23.417c4.142,0,7.5-3.358,7.5-7.5V7.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v8.417   C54.762,20.059,58.12,23.417,62.262,23.417z"
            fill="#0087ff"
            data-original="#0087ff"
          ></path>
          <path
            d="M17.99,0c-4.142,0-7.5,3.358-7.5,7.5v8.417c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V7.5   C25.49,3.358,22.132,0,17.99,0z"
            fill="#0087ff"
            data-original="#0087ff"
          ></path>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};

export default ExchangeIcon;
